"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffInDays = void 0;
const diffInDays = (date1, date2) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    return Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
};
exports.diffInDays = diffInDays;
